import { render, staticRenderFns } from "./Decomposition.vue?vue&type=template&id=660de954&scoped=true&"
import script from "./Decomposition.vue?vue&type=script&lang=ts&"
export * from "./Decomposition.vue?vue&type=script&lang=ts&"
import style0 from "./Decomposition.vue?vue&type=style&index=0&id=660de954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660de954",
  null
  
)

export default component.exports